// A background save (questionnaire autosave and the like) or a piece of HTML an editor loads, answered
// by an ended session or a stale page, used to fail without a word (#297). The server marks that answer
// with X-Session-Expired and sends the message and a link (sign in again, or reload the page); every
// fetch on the page is watched, so no caller can miss it.
const BANNER_ID = "session-expired-banner"

function showBanner({ message, action_url: actionUrl, action_label: actionLabel }) {
  if (document.getElementById(BANNER_ID)) return

  const banner = document.createElement("div")
  banner.id = BANNER_ID
  banner.setAttribute("role", "alert")
  banner.className = "fixed inset-x-0 top-0 z-[100] bg-red-700 text-white shadow-lg"

  const inner = document.createElement("div")
  inner.className = "mx-auto max-w-5xl px-4 py-3 flex flex-col sm:flex-row sm:items-center gap-3 justify-between"

  const text = document.createElement("p")
  text.className = "text-sm font-semibold"
  text.textContent = message

  const link = document.createElement("a")
  link.href = actionUrl || "/sign_in"
  link.className = "inline-flex items-center justify-center rounded-md bg-white px-4 py-2 text-sm font-semibold text-red-700 hover:bg-red-50"
  link.textContent = actionLabel
  link.dataset.turbo = "false"

  inner.append(text, link)
  banner.append(inner)
  document.body.append(banner)
  link.focus()
}

export function watchSessionExpiry() {
  if (window.__sessionExpiryWatched) return
  window.__sessionExpiryWatched = true

  const originalFetch = window.fetch.bind(window)
  window.fetch = async (...args) => {
    const response = await originalFetch(...args)
    if (response.headers.get("X-Session-Expired") === "1") {
      response.clone().json().then(showBanner).catch(() => {})
    }
    return response
  }

  // Image uploads in the backoffice editors go through XMLHttpRequest (Active Storage's DirectUpload),
  // not fetch: an editor whose session ended learns it the same way (#255).
  const originalSend = XMLHttpRequest.prototype.send
  XMLHttpRequest.prototype.send = function (...args) {
    this.addEventListener("load", () => {
      if (this.getResponseHeader("X-Session-Expired") !== "1") return
      // DirectUpload asks for responseType "json", where responseText cannot be read.
      try {
        showBanner(this.responseType === "json" ? this.response : JSON.parse(this.responseText))
      } catch (_error) { /* not the JSON answer */ }
    })
    return originalSend.apply(this, args)
  }
}
